module.exports = __webpack_public_path__ + "img/badge_hoepli.fa5a379b.jpg";